// ============================================================
// "FOTOGRAFIJA" PODATAKA NA FAKTURI — prodavac i kupac kakvi su bili kad je faktura sačuvana.
// Kasnije izmene firme ili klijenta ne menjaju već izdate fakture.
// Logo se ne kopira (velik je) — ostaje zajednički iz podataka firme.
// ============================================================

const pick = (obj, keys) => Object.fromEntries(keys.map((k) => [k, obj[k] ?? null]));

const SELLER_KEYS = [
  'company_name', 'short_name', 'owner_name', 'name_display',
  'street', 'street_number', 'postal_code', 'city',
  'pib', 'mb', 'phone', 'email',
  'account_dom', 'account_ino', 'iban_bank', 'swift',
];

const BUYER_KEYS = ['name', 'address', 'postal_code', 'city', 'country', 'is_foreign', 'pib', 'mb'];

export const sellerSnapshot = (profile) => (profile ? pick(profile, SELLER_KEYS) : null);
export const buyerSnapshot = (customer) => (customer ? pick(customer, BUYER_KEYS) : null);

// Za prikaz: fotografija ima prednost, a današnji podaci dopunjuju ostalo (logo, id, e-mail klijenta)
export const withSnapshot = (live, snapshot) => (snapshot ? { ...(live || {}), ...snapshot } : live);
